import React from 'react';

export const ComposeBox = ({
  textareaRef, input, setInput, isSignedIn, warningBanner, setWarningBanner,
  charLimitWarning, setCharLimitWarning, MAX_CHAR_HOME, handleTextareaWheel,
  isMobileView, loading
}) => {
  const handleChange = (e) => {
    const newValue = e.target.value;
    
    // AUTH CHECK: Show message if non-logged-in user tries to type
    if (!isSignedIn && newValue.length > 0 && !input) {
      setWarningBanner({
        type: 'auth',
        message: 'Please log in to generate prompts'
      });
    }
    
    // Clear warning banner when user starts typing again (for other warning types)
    if (warningBanner && warningBanner.type !== 'auth') {
      setWarningBanner(null);
    }
    
    if (newValue.length <= MAX_CHAR_HOME) {
      setInput(newValue);
      if (charLimitWarning) {
        setCharLimitWarning(false);
      }
    } else {
      setCharLimitWarning(true);
    }
  };

  return (
    <div className="mb-3">
      <div className="relative">
        <textarea
          ref={textareaRef}
          value={input}
          onChange={handleChange}
          onWheel={handleTextareaWheel}
          placeholder={isMobileView ? "What do you want to build or fix?" : "What do you want to build or fix?"}
          className="compose-box compose-box-with-cursor w-full h-40 md:h-48 p-3 md:p-4 pb-8 rounded-xl text-sm md:text-base resize-y"
          disabled={loading}
          style={{ 
            minHeight: '192px', 
            maxHeight: '600px',
            opacity: loading ? 0.5 : 1,
            cursor: loading ? 'not-allowed' : 'text',
            maxWidth: '100%',
            boxSizing: 'border-box'
          }}
        />
        {isSignedIn && (
          <div className="absolute bottom-2 right-3 text-[0.6rem] text-gray-400 opacity-80 pointer-events-none">
            {input.length} / {MAX_CHAR_HOME}
          </div>
        )}
      </div>
      {!isSignedIn && input.length > MAX_CHAR_HOME * 0.7 && (
        <div className="text-right mt-1.5">
          <span className="text-[#BF5743] text-xs font-medium">
            Sign in for {10000 - MAX_CHAR_HOME} more characters
          </span>
        </div>
      )}
    </div>
  );
};
